exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buttons {\r\n    padding: 15px;\r\n}\r\n\r\n.confirm-dialog {\r\n    padding: 15px;\r\n    font-size:150%;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();